
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-zoom_in_map",
  "use": "icon-material-zoom_in_map-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-zoom_in_map\"><path d=\"m143.96-94.98-48.98-48.98 142.93-142.93H114.02v-68.13h241v241h-68.13v-123.89zm672.08 0L673.35-237.91v123.89h-68.37v-241h241.24v68.13H722.09l142.93 142.93zm-702.02-510v-68.37h123.89L94.98-816.04l48.98-48.98 142.93 142.93v-124.13h68.13v241.24zm490.96 0v-241.24h68.37v124.13l143.69-143.93 48.98 48.98-143.93 143.69h124.13v68.37z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-zoom_in_map"/>
                </svg>
            );
        };

        Icon.id = "icon-material-zoom_in_map";

        export default Icon;
    